// 261010 P9D D5 (Rev 3 mục 4) — bước 1 đã có kết quả mà còn video vượt trần engine: nói số video + nút RIÊNG «Chạy lại Phân đoạn (chặng 1)».
// Không tự chạy, không route mới: bấm ⇒ `RUN_STAGE1` (hộp xác nhận RERUN_STAGE1). Logic thuần ở `workflowStructOps.needsSplitBannerOf` + `workflowPrimaryPolicy.scriptRerunCallOf`.
import React from 'react';
import type { PrimaryCall } from './workflowPrimaryPolicy';
import type { NeedsSplitBanner } from './workflowStructOps';

interface Props {
  banner: NeedsSplitBanner;
  eventOrders: number[];
  call: PrimaryCall | null;
  sending: boolean;
  onRun: (call: PrimaryCall | null) => void;
}

const WorkflowNeedsSplitBanner: React.FC<Props> = ({ banner, eventOrders, call, sending, onRun }) => (
  <div className="wf-alert WARN" role="status" data-testid="wf-needs-split">
    <b>{banner.text}</b>{' '}
    <span className="muted">Video {eventOrders.join(', ')}. Chạy lại Phân đoạn để máy thử chia lại, hoặc cắt tay (Cắt đôi) ở từng video.</span>
    {banner.confirmNote ? <span className="muted"> {banner.confirmNote}</span> : null}
    <div style={{ marginTop: 6 }}>
      <button type="button" className="wf-btn" disabled={!call || sending} title={call ? undefined : 'Đang có việc chạy trên plan — đợi xong.'} onClick={() => onRun(call)} data-testid="wf-needs-split-rerun">Chạy lại Phân đoạn (chặng 1)</button>
    </div>
  </div>
);

export default WorkflowNeedsSplitBanner;
